import {Component, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {AnnouncementService, Claim, PolicyConfig} from '@app/views/common/dialog-announcement/announcement.service';
import {environment} from '@env/environment';

@Component({
    selector   : 'ngc-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls  : ['./terms-of-use.component.scss']
})
export class NgcTermsOfUseComponent implements OnInit, OnDestroy {

    claimName = 'gg4l.connect.terms.use';
    claim: Claim;
    documentUrl: string;
    isHtmlDocumentLoading$ = new BehaviorSubject(false);

    constructor(
        private announcementService: AnnouncementService
    ) {
    }

    ngOnInit() {

        this.announcementService.checkClaimsForClaimRequest(this.claimName)
            .subscribe((conf: PolicyConfig) => {
                if (conf.claims && conf.claims.length > 0) {
                    this.claim = conf.claims[0];
                    this.documentUrl = `${environment.datahubBaseURI}/api/v2/announcement/document/${this.claim.id}/${this.claim.internalFormat}`;
                }
            });
    }

    public ngOnDestroy() {

    }
}
